import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { CalendarComponent } from 'src/app/common/calender/calender.component';
import { extractDatesFromDateString, getDefaultDatesOfYear } from 'src/app/common/calender/calender.utilities';
import { ICalenderEvent } from 'src/app/common/calender/calender.types';
import { Actions, Getters } from 'src/app/store';

@Component({
  selector: 'app-dashboard-filters',
  templateUrl: './dashboard-filters.component.html',
  styleUrls: ['./dashboard-filters.component.css']
})
export class DashboardFiltersComponent implements OnInit {
  @ViewChild(CalendarComponent) calenderComponent!: CalendarComponent;

  // Dropdown options for filterDate
  filterDateOptions = [
    { label: 'Ex Date', value: 'exDate' },
    { label: 'Pay Date', value: 'payDate' },
    { label: 'Tax Report Date', value: 'taxReportDate' }
  ];

  // input values
  formGroup = new FormGroup({
    securityId: new FormControl<string | null>(null, Validators.required),
    startDate: new FormControl('', Validators.required),
    endDate: new FormControl('', Validators.required),
    filterDate: new FormControl<string>('exDate', Validators.required)
  });

  dateRange!: Date[] | null;

  constructor(private router: Router, public route: ActivatedRoute, private readonly storeService: Actions, private getStoreService: Getters) {}

  ngOnInit(): void {
    const { securityId, startDate, endDate, filterDate } = this.route.snapshot.queryParams;
    if (securityId) {
      this.initialiseSecurity(securityId);
    } else {
      const storeSecurityId = this.getStoreService.securityId();
      const data = { securityId: storeSecurityId };
      this.onUpdateParams(data);
      this.initialiseSecurity(storeSecurityId || '');
    }
    this.initialiseDates(startDate, endDate);
    this.initialiseFilterDate(filterDate);
  }

  private initialiseSecurity = (securityId: string) => {
    this.formGroup.patchValue({ securityId });
  };

  private initialiseFilterDate = (filterDate: string) => {
    // Validate filterDate; default to 'exDate' if invalid or undefined
    const validFilterDates = ['exDate', 'payDate', 'taxReportDate'];
    const validFilterDate = validFilterDates.includes(filterDate) ? filterDate : 'exDate';
    this.formGroup.patchValue({ filterDate: validFilterDate });
  };

  private initialiseDates = (startDate: string, endDate: string) => {
    if (startDate && endDate) {
      const { dateFilter } = extractDatesFromDateString(startDate, endDate);
      this.dateRange = dateFilter;
    } else {
      const { dateFilter } = getDefaultDatesOfYear(true);
      this.dateRange = dateFilter;
    }
  };

  get isFormValid() {
    const values = this.formGroup.value;
    return values.securityId && values.startDate && values.endDate;
  }

  get isFormDirty() {
    const values = this.formGroup.value;
    return !(values.securityId || values.startDate || values.endDate || values.filterDate);
  }

  onChangeDates = ({ fromDate, toDate }: ICalenderEvent) => {
    this.formGroup.patchValue({
      startDate: fromDate,
      endDate: toDate
    });
  };

  onConfirm() {
    // we can assume the data is valid at this point
    const data = { ...this.formGroup.value };
    this.onUpdateParams(data);
  }

  onReset() {
    this.formGroup.patchValue({
      securityId: null,
      filterDate: 'exDate'
    });
    const { dateFilter } = getDefaultDatesOfYear(true);
    this.calenderComponent?.onReset(dateFilter);
    this.onUpdateParams({});
  }

  // Fn to update query params
  onUpdateParams = (data: any) => {
    this.storeService.setSecurityId(data.securityId);
    this.router.navigate(['./'], {
      relativeTo: this.route,
      queryParams: data
    });
  };
}